import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { LsFormRowColumnsSelectComponent } from './ls-form-row-column-select.component';
import { LsRowColumnSelectComponent } from './ls-row-column-select.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule],
  declarations: [LsRowColumnSelectComponent, LsFormRowColumnsSelectComponent],
  exports: [LsRowColumnSelectComponent, LsFormRowColumnsSelectComponent]
})
export class LsRowColumnSelectModule {}
